import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from './User'

// Pre-auth pages (login, error, etc.) render in the i18n default ('en').
// Once we know who's logged in, switch to their stored preference.
export function useSyncLanguage() {
  const { data: authenticatedUser } = useAuthenticatedUser()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (
      authenticatedUser?.language_interface &&
      authenticatedUser.language_interface !== i18n.language
    ) {
      i18n.changeLanguage(authenticatedUser.language_interface)
    }
  }, [authenticatedUser?.language_interface, i18n])
}
